import React, {useEffect, useRef} from 'react';
import type {TextFieldProps} from 'components/types';
import {Layout} from '../layout';

type Props = Pick<
  TextFieldProps,
  'placeholder' | 'onChange' | 'onBlur' | 'error' | 'className' | 'required'
> & {
  value: string | null;
  name?: string;
  readonly?: boolean;
  maxLength?: number;
  rows?: number;
  warning?: boolean;
};

export const TextAreaEditable: React.FC<Props> = ({
  value,
  name,
  placeholder,
  error,
  warning,
  maxLength,
  rows = 3,
  className,
  onChange,
  onBlur,
  required,
}) => {
  const ref = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.style.height = '';
      ref.current.style.height = `${(ref.current?.scrollHeight ?? 0) + 0}px`;
    }
  }, []);

  return (
    <Layout padding={2} focusable error={error} warning={warning}>
      <textarea
        id={name}
        ref={ref}
        name={name}
        value={value ?? ''}
        placeholder={placeholder}
        maxLength={maxLength}
        className={className}
        required={required}
        style={{
          resize: 'none',
          fontFamily: 'inherit',
          fontSize: 'inherit',
          color: 'inherit',
          height: `${(ref.current?.scrollHeight ?? 0) + 0}px`,
        }}
        onInput={() => {
          if (ref.current) {
            ref.current.style.height = '';
            ref.current.style.height = `${
              ref.current?.scrollHeight ?? 0 + 0
            }px`;
          }
        }}
        rows={rows}
        onChange={onChange}
        onBlur={onBlur}
      />
    </Layout>
  );
};
